import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { BrowserRouter } from "react-router-dom"
import { ModalContextProvider } from "./components/contexts/ModalContext"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { pdfjs } from "react-pdf"
import { SidePanelContextProvider } from "./components/contexts/SidePanelContext"
import { SelfUserContextProvider } from "./components/contexts/SelfUserContext"
import { CookiesProvider } from "react-cookie"
import { AuthContextProvider } from "./components/contexts/AuthContext"
import { SessionAbilityProvider } from "./components/contexts/AbilityContext"
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

pdfjs.GlobalWorkerOptions.workerSrc =
    process.env.NODE_ENV === "production"
        ? new URL(window.location.origin + "/pdf-js/pdf.worker.min.mjs", import.meta.url).toString()
        : new URL("/public/pdf-js/pdf.worker.min.mjs", import.meta.url).toString()

root.render(
    // <React.StrictMode>
    <QueryClientProvider client={new QueryClient()}>
        <CookiesProvider defaultSetOptions={{ path: "/" }}>
            <BrowserRouter>
                <ModalContextProvider>
                    <SidePanelContextProvider>
                        <AuthContextProvider>
                            <SessionAbilityProvider>
                                <SelfUserContextProvider>
                                    <App />
                                </SelfUserContextProvider>
                            </SessionAbilityProvider>
                        </AuthContextProvider>
                    </SidePanelContextProvider>
                </ModalContextProvider>
            </BrowserRouter>
        </CookiesProvider>
    </QueryClientProvider>
    // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
